import { countriesEuropeES } from 'const/countriesEurope';

const views = {
	signatureRead: {
		docNames: {
			NOTA_INFORMATIVA: 'Solicitud y Nota Informativa',
		},
	},
	identityBiometrics: {
		steps: {
			selectDocumentCountry: false,
			selectDocumentType: {
				include: false,
				validDocumentCountries: countriesEuropeES,
				validDocumentTypes: [
					{ value: 'dni', label: 'DNI' },
					{ value: 'driverLicense', label: 'Carnet de conducir' },
				],
			},
			provider: 'alice', // alice or manual
			addExtraDocuments: false,
		},
	},
};

export default views;
